export type FontOption = {
  label: string;
  value: string;
  provider?: 'google' | 'web-safe';
};

export const WEB_SAFE_FONTS: FontOption[] = [
  { value: "Arial, sans-serif", label: "Arial" },
  { value: "Helvetica, Arial, sans-serif", label: "Helvetica" },
  { value: "Georgia, serif", label: "Georgia" },
  { value: '"Times New Roman", Times, serif', label: "Times New Roman" },
  { value: "Verdana, Geneva, sans-serif", label: "Verdana" },
  { value: "Tahoma, Geneva, sans-serif", label: "Tahoma" },
  { value: '"Trebuchet MS", Helvetica, sans-serif', label: "Trebuchet MS" },
  { value: 'Palatino, "Palatino Linotype", serif', label: "Palatino" },
  { value: "Garamond, serif", label: "Garamond" },
  { value: '"Courier New", Courier, monospace', label: "Courier New" },
  { value: '"Segoe UI", Tahoma, Geneva, sans-serif', label: "Segoe UI" },
];

export const GOOGLE_FONTS: FontOption[] = [
  // --- TOP 10 MOST POPULAR ---
  { value: '"Roboto", sans-serif', label: "Roboto", provider: 'google' },
  { value: '"Open Sans", sans-serif', label: "Open Sans", provider: 'google' },
  { value: '"Lato", sans-serif', label: "Lato", provider: 'google' },
  { value: '"Montserrat", sans-serif', label: "Montserrat", provider: 'google' },
  { value: '"Poppins", sans-serif', label: "Poppins", provider: 'google' },
  { value: '"Oswald", sans-serif', label: "Oswald", provider: 'google' },
  { value: '"Source Sans 3", sans-serif', label: "Source Sans 3", provider: 'google' },
  { value: '"Raleway", sans-serif', label: "Raleway", provider: 'google' },
  { value: '"Merriweather", serif', label: "Merriweather", provider: 'google' },
  { value: '"Playfair Display", serif', label: "Playfair Display", provider: 'google' },

  // --- POPULAR SANS-SERIF FONTS (A-Z) ---
  { value: '"Abel", sans-serif', label: "Abel", provider: 'google' },
  { value: '"Alegreya Sans", sans-serif', label: "Alegreya Sans", provider: 'google' },
  { value: '"Archivo", sans-serif', label: "Archivo", provider: 'google' },
  { value: '"Assistant", sans-serif', label: "Assistant", provider: 'google' },
  { value: '"Barlow", sans-serif', label: "Barlow", provider: 'google' },
  { value: '"Bebas Neue", sans-serif', label: "Bebas Neue", provider: 'google' },
  { value: '"Cabin", sans-serif', label: "Cabin", provider: 'google' },
  { value: '"Cantarell", sans-serif', label: "Cantarell", provider: 'google' },
  { value: '"Chivo", sans-serif', label: "Chivo", provider: 'google' },
  { value: '"Comfortaa", sans-serif', label: "Comfortaa", provider: 'google' },
  { value: '"Cormorant Garamond", serif', label: "Cormorant Garamond", provider: 'google' },
  { value: '"DM Sans", sans-serif', label: "DM Sans", provider: 'google' },
  { value: '"Encode Sans", sans-serif', label: "Encode Sans", provider: 'google' },
  { value: '"Exo 2", sans-serif', label: "Exo 2", provider: 'google' },
  { value: '"Fira Sans", sans-serif', label: "Fira Sans", provider: 'google' },
  { value: '"Fjalla One", sans-serif', label: "Fjalla One", provider: 'google' },
  { value: '"Heebo", sans-serif', label: "Heebo", provider: 'google' },
  { value: '"Inter", sans-serif', label: "Inter", provider: 'google' },
  { value: '"Josefin Sans", sans-serif', label: "Josefin Sans", provider: 'google' },
  { value: '"Jost", sans-serif', label: "Jost", provider: 'google' },
  { value: '"Kanit", sans-serif', label: "Kanit", provider: 'google' },
  { value: '"Karla", sans-serif', label: "Karla", provider: 'google' },
  { value: '"Libre Franklin", sans-serif', label: "Libre Franklin", provider: 'google' },
  { value: '"Manrope", sans-serif', label: "Manrope", provider: 'google' },
  { value: '"Mulish", sans-serif', label: "Mulish", provider: 'google' },
  { value: '"Noto Sans", sans-serif', label: "Noto Sans", provider: 'google' },
  { value: '"Nunito", sans-serif', label: "Nunito", provider: 'google' },
  { value: '"Nunito Sans", sans-serif', label: "Nunito Sans", provider: 'google' },
  { value: '"Overpass", sans-serif', label: "Overpass", provider: 'google' },
  { value: '"Prompt", sans-serif', label: "Prompt", provider: 'google' },
  { value: '"Quicksand", sans-serif', label: "Quicksand", provider: 'google' },
  { value: '"Rubik", sans-serif', label: "Rubik", provider: 'google' },
  { value: '"Teko", sans-serif', label: "Teko", provider: 'google' },
  { value: '"Titillium Web", sans-serif', label: "Titillium Web", provider: 'google' },
  { value: '"Ubuntu", sans-serif', label: "Ubuntu", provider: 'google' },
  { value: '"Varela Round", sans-serif', label: "Varela Round", provider: 'google' },
  { value: '"Work Sans", sans-serif', label: "Work Sans", provider: 'google' },

  // --- POPULAR SERIF FONTS (A-Z) ---
  { value: '"Alegreya", serif', label: "Alegreya", provider: 'google' },
  { value: '"Arvo", serif', label: "Arvo", provider: 'google' },
  { value: '"Cormorant", serif', label: "Cormorant", provider: 'google' },
  { value: '"EB Garamond", serif', label: "EB Garamond", provider: 'google' },
  { value: '"Fenix", serif', label: "Fenix", provider: 'google' },
  { value: '"Frank Ruhl Libre", serif', label: "Frank Ruhl Libre", provider: 'google' },
  { value: '"Libre Baskerville", serif', label: "Libre Baskerville", provider: 'google' },
  { value: '"Lora", serif', label: "Lora", provider: 'google' },
  { value: '"Noto Serif", serif', label: "Noto Serif", provider: 'google' },
  { value: '"PT Serif", serif', label: "PT Serif", provider: 'google' },
  { value: '"Spectral", serif', label: "Spectral", provider: 'google' },
  { value: '"Taviraj", serif', label: "Taviraj", provider: 'google' },
  { value: '"Volkhov", serif', label: "Volkhov", provider: 'google' },
  { value: '"Vollkorn", serif', label: "Vollkorn", provider: 'google' },
  { value: '"Zilla Slab", serif', label: "Zilla Slab", provider: 'google' },

  // --- DISPLAY/SCRIPT/MONOSPACE AND ADDITIONAL POPULAR FONTS (A-Z) ---
  { value: '"Alata", sans-serif', label: "Alata", provider: 'google' },
  { value: '"Amatic SC", cursive', label: "Amatic SC", provider: 'google' },
  { value: '"Anton", sans-serif', label: "Anton", provider: 'google' },
  { value: '"Bangers", cursive', label: "Bangers", provider: 'google' },
  { value: '"BioRhyme", serif', label: "BioRhyme", provider: 'google' },
  { value: '"Bree Serif", serif', label: "Bree Serif", provider: 'google' },
  { value: '"Caveat", cursive', label: "Caveat", provider: 'google' },
  { value: '"Cinzel", serif', label: "Cinzel", provider: 'google' },
  { value: '"Cookie", cursive', label: "Cookie", provider: 'google' },
  { value: '"Courgette", cursive', label: "Courgette", provider: 'google' },
  { value: '"Crimson Text", serif', label: "Crimson Text", provider: 'google' },
  { value: '"Dancing Script", cursive', label: "Dancing Script", provider: 'google' },
  { value: '"Domine", serif', label: "Domine", provider: 'google' },
  { value: '"Faustina", serif', label: "Faustina", provider: 'google' },
  { value: '"Great Vibes", cursive', label: "Great Vibes", provider: 'google' },
  { value: '"Handlee", cursive', label: "Handlee", provider: 'google' },
  { value: '"IBM Plex Sans", sans-serif', label: "IBM Plex Sans", provider: 'google' },
  { value: '"Inconsolata", monospace', label: "Inconsolata", provider: 'google' },
  { value: '"Indie Flower", cursive', label: "Indie Flower", provider: 'google' },
  { value: '"Kalam", cursive', label: "Kalam", provider: 'google' },
  { value: '"Libre Barcode 39", monospace', label: "Libre Barcode 39", provider: 'google' },
  { value: '"Lobster", cursive', label: "Lobster", provider: 'google' },
  { value: '"Maven Pro", sans-serif', label: "Maven Pro", provider: 'google' },
  { value: '"Mochiy Pop P One", sans-serif', label: "Mochiy Pop P One", provider: 'google' },
  { value: '"Monoton", cursive', label: "Monoton", provider: 'google' },
  { value: '"Permanent Marker", cursive', label: "Permanent Marker", provider: 'google' },
  { value: '"Pixelify Sans", sans-serif', label: "Pixelify Sans", provider: 'google' },
  { value: '"Press Start 2P", cursive', label: "Press Start 2P", provider: 'google' },
  { value: '"Proza Libre", sans-serif', label: "Proza Libre", provider: 'google' },
  { value: '"Satisfy", cursive', label: "Satisfy", provider: 'google' },
  { value: '"Space Mono", monospace', label: "Space Mono", provider: 'google' },
  { value: '"Special Elite", cursive', label: "Special Elite", provider: 'google' },
  { value: '"Syne", sans-serif', label: "Syne", provider: 'google' },
  { value: '"Tinos", serif', label: "Tinos", provider: 'google' },
  { value: '"Trispace", sans-serif', label: "Trispace", provider: 'google' },
  { value: '"Yantramanav", sans-serif', label: "Yantramanav", provider: 'google' },
  { value: '"Zeyada", cursive', label: "Zeyada", provider: 'google' },

  // --- ADDITIONAL SANS-SERIF FONTS (A-Z) ---
//   { value: '"Acme", sans-serif', label: "Acme", provider: 'google' },
//   { value: '"Alice", serif', label: "Alice", provider: 'google' },
//   { value: '"Antic Slab", serif', label: "Antic Slab", provider: 'google' },
//   { value: '"Archivo Narrow", sans-serif', label: "Archivo Narrow", provider: 'google' },
//   { value: '"Asap", sans-serif', label: "Asap", provider: 'google' },
//   { value: '"Average", serif', label: "Average", provider: 'google' },
//   { value: '"Bad Script", cursive', label: "Bad Script", provider: 'google' },
//   { value: '"Basic", sans-serif', label: "Basic", provider: 'google' },
//   { value: '"BenchNine", sans-serif', label: "BenchNine", provider: 'google' },
//   { value: '"Bitter", serif', label: "Bitter", provider: 'google' },
//   { value: '"Boogaloo", cursive', label: "Boogaloo", provider: 'google' },
//   { value: '"Calistoga", sans-serif', label: "Calistoga", provider: 'google' },
//   { value: '"Candal", sans-serif', label: "Candal", provider: 'google' },
//   { value: '"Catamaran", sans-serif', label: "Catamaran", provider: 'google' },
//   { value: '"Caveat Brush", cursive', label: "Caveat Brush", provider: 'google' },
//   { value: '"Chakra Petch", sans-serif', label: "Chakra Petch", provider: 'google' },
//   { value: '"Chelsea Market", cursive', label: "Chelsea Market", provider: 'google' },
//   { value: '"Chewy", cursive', label: "Chewy", provider: 'google' },
//   { value: '"Chonburi", serif', label: "Chonburi", provider: 'google' },
//   { value: '"Coda", cursive', label: "Coda", provider: 'google' },
//   { value: '"Concert One", sans-serif', label: "Concert One", provider: 'google' },
//   { value: '"Contrail One", cursive', label: "Contrail One", provider: 'google' },
//   { value: '"Cousine", monospace', label: "Cousine", provider: 'google' },
//   { value: '"Cuprum", sans-serif', label: "Cuprum", provider: 'google' },
//   { value: '"Days One", sans-serif', label: "Days One", provider: 'google' },
//   { value: '"Dosis", sans-serif', label: "Dosis", provider: 'google' },
//   { value: '"Droid Sans", sans-serif', label: "Droid Sans", provider: 'google' },
//   { value: '"Economica", sans-serif', label: "Economica", provider: 'google' },
//   { value: '"El Messiri", sans-serif', label: "El Messiri", provider: 'google' },
//   { value: '"Faster One", cursive', label: "Faster One", provider: 'google' },
//   { value: '"Federo", sans-serif', label: "Federo", provider: 'google' },
//   { value: '"Figtree", sans-serif', label: "Figtree", provider: 'google' },
//   { value: '"Fredoka One", cursive', label: "Fredoka One", provider: 'google' },
//   { value: '"Fugaz One", cursive', label: "Fugaz One", provider: 'google' },
//   { value: '"Gelasio", serif', label: "Gelasio", provider: 'google' },
//   { value: '"Gruppo", sans-serif', label: "Gruppo", provider: 'google' },
//   { value: '"Gudea", sans-serif', label: "Gudea", provider: 'google' },
//   { value: '"Hammersmith One", sans-serif', label: "Hammersmith One", provider: 'google' },
//   { value: '"Hanken Grotesk", sans-serif', label: "Hanken Grotesk", provider: 'google' },
//   { value: '"Hind", sans-serif', label: "Hind", provider: 'google' },
//   { value: '"Inria Sans", sans-serif', label: "Inria Sans", provider: 'google' },
//   { value: '"Istok Web", sans-serif', label: "Istok Web", provider: 'google' },
//   { value: '"Jaldi", sans-serif', label: "Jaldi", provider: 'google' },
//   { value: '"Jomhuria", serif', label: "Jomhuria", provider: 'google' },
//   { value: '"Jura", sans-serif', label: "Jura", provider: 'google' },
//   { value: '"Kameron", serif', label: "Kameron", provider: 'google' },
//   { value: '"Krona One", sans-serif', label: "Krona One", provider: 'google' },
//   { value: '"Kumbh Sans", sans-serif', label: "Kumbh Sans", provider: 'google' },
//   { value: '"Lalezar", cursive', label: "Lalezar", provider: 'google' },
//   { value: '"Lekton", monospace', label: "Lekton", provider: 'google' },
//   { value: '"Limelight", cursive', label: "Limelight", provider: 'google' },
//   { value: '"Literata", serif', label: "Literata", provider: 'google' },
//   { value: '"Liu Jian Mao Cao", cursive', label: "Liu Jian Mao Cao", provider: 'google' },
//   { value: '"M PLUS 1p", sans-serif', label: "M PLUS 1p", provider: 'google' },
//   { value: '"M PLUS Rounded 1c", sans-serif', label: "M PLUS Rounded 1c", provider: 'google' },
//   { value: '"Mada", sans-serif', label: "Mada", provider: 'google' },
//   { value: '"Major Mono Display", monospace', label: "Major Mono Display", provider: 'google' },
//   { value: '"Marcellus", serif', label: "Marcellus", provider: 'google' },
//   { value: '"Markazi Text", serif', label: "Markazi Text", provider: 'google' },
//   { value: '"Meie Script", cursive', label: "Meie Script", provider: 'google' },
//   { value: '"Michroma", sans-serif', label: "Michroma", provider: 'google' },
//   { value: '"Miriam Libre", sans-serif', label: "Miriam Libre", provider: 'google' },
//   { value: '"Mitr", sans-serif', label: "Mitr", provider: 'google' },
//   { value: '"Molengo", sans-serif', label: "Molengo", provider: 'google' },
//   { value: '"News Cycle", sans-serif', label: "News Cycle", provider: 'google' },
//   { value: '"Niramit", sans-serif', label: "Niramit", provider: 'google' },
//   { value: '"Noto Color Emoji", sans-serif', label: "Noto Color Emoji", provider: 'google' },
//   { value: '"Old Standard TT", serif', label: "Old Standard TT", provider: 'google' },
//   { value: '"Oxygen", sans-serif', label: "Oxygen", provider: 'google' },
//   { value: '"Padauk", sans-serif', label: "Padauk", provider: 'google' },
//   { value: '"Palanquin", sans-serif', label: "Palanquin", provider: 'google' },
//   { value: '"Patua One", cursive', label: "Patua One", provider: 'google' },
//   { value: '"Philosopher", sans-serif', label: "Philosopher", provider: 'google' },
//   { value: '"Play", sans-serif', label: "Play", provider: 'google' },
//   { value: '"Podkova", serif', label: "Podkova", provider: 'google' },
//   { value: '"Prata", serif', label: "Prata", provider: 'google' },
//   { value: '"Pridi", sans-serif', label: "Pridi", provider: 'google' },
//   { value: '"Quando", serif', label: "Quando", provider: 'google' },
//   { value: '"Quantico", sans-serif', label: "Quantico", provider: 'google' },
//   { value: '"Rajdhani", sans-serif', label: "Rajdhani", provider: 'google' },
//   { value: '"Ranchers", cursive', label: "Ranchers", provider: 'google' },
//   { value: '"Righteous", cursive', label: "Righteous", provider: 'google' },
//   { value: '"Rokkitt", serif', label: "Rokkitt", provider: 'google' },
//   { value: '"Ropa Sans", sans-serif', label: "Ropa Sans", provider: 'google' },
//   { value: '"Rufina Display", serif', label: "Rufina Display", provider: 'google' },
//   { value: '"Sacramento", cursive', label: "Sacramento", provider: 'google' },
//   { value: '"Saira", sans-serif', label: "Saira", provider: 'google' },
//   { value: '"Saira Condensed", sans-serif', label: "Saira Condensed", provider: 'google' },
//   { value: '"Sanchez", serif', label: "Sanchez", provider: 'google' },
//   { value: '"Secular One", sans-serif', label: "Secular One", provider: 'google' },
//   { value: '"Share Tech Mono", monospace', label: "Share Tech Mono", provider: 'google' },
//   { value: '"Six Caps", sans-serif', label: "Six Caps", provider: 'google' },
//   { value: '"Slabo 27px", serif', label: "Slabo 27px", provider: 'google' },
//   { value: '"Sora", sans-serif', label: "Sora", provider: 'google' },
//   { value: '"Source Code Pro", monospace', label: "Source Code Pro", provider: 'google' },
//   { value: '"Stint Ultra Condensed", cursive', label: "Stint Ultra Condensed", provider: 'google' },
//   { value: '"Suez One", serif', label: "Suez One", provider: 'google' },
//   { value: '"Sulphur Point", sans-serif', label: "Sulphur Point", provider: 'google' },
//   { value: '"Tangerine", cursive', label: "Tangerine", provider: 'google' },
//   { value: '"Tenor Sans", sans-serif', label: "Tenor Sans", provider: 'google' },
//   { value: '"Thasadith", sans-serif', label: "Thasadith", provider: 'google' },
//   { value: '"Trirong", serif', label: "Trirong", provider: 'google' },
//   { value: '"Unica One", sans-serif', label: "Unica One", provider: 'google' },
//   { value: '"Viaoda Libre", cursive', label: "Viaoda Libre", provider: 'google' },
//   { value: '"Vidaloka", serif', label: "Vidaloka", provider: 'google' },
//   { value: '"Vollkorn SC", serif', label: "Vollkorn SC", provider: 'google' },
//   { value: '"Yanone Kaffeesatz", sans-serif', label: "Yanone Kaffeesatz", provider: 'google' },
//   { value: '"Yeseva One", cursive', label: "Yeseva One", provider: 'google' },
//   { value: '"ZCOOL KuaiLe", cursive', label: "ZCOOL KuaiLe", provider: 'google' },

  // --- EXTENDED POPULAR FONTS (A-Z) ---
  { value: '"Actor", sans-serif', label: "Actor", provider: 'google' },
  { value: '"Adamina", serif', label: "Adamina", provider: 'google' },
  { value: '"Alef", sans-serif', label: "Alef", provider: 'google' },
  { value: '"Almarai", sans-serif', label: "Almarai", provider: 'google' },
  { value: '"Alumni Sans", sans-serif', label: "Alumni Sans", provider: 'google' },
  { value: '"Amiri", serif', label: "Amiri", provider: 'google' },
  { value: '"Andada Pro", serif', label: "Andada Pro", provider: 'google' },
  { value: '"Annie Use Your Telescope", cursive', label: "Annie Use Your Telescope", provider: 'google' },
  { value: '"Anonymous Pro", monospace', label: "Anonymous Pro", provider: 'google' },
  { value: '"Antic", sans-serif', label: "Antic", provider: 'google' },
  { value: '"Anybody", sans-serif', label: "Anybody", provider: 'google' },
  { value: '"Arbutus Slab", serif', label: "Arbutus Slab", provider: 'google' },
  { value: '"Architects Daughter", cursive', label: "Architects Daughter", provider: 'google' },
  { value: '"Arapey", serif', label: "Arapey", provider: 'google' },
  { value: '"Asul", sans-serif', label: "Asul", provider: 'google' },
  { value: '"Atkinson Hyperlegible", sans-serif', label: "Atkinson Hyperlegible", provider: 'google' },
  { value: '"Average Sans", sans-serif', label: "Average Sans", provider: 'google' },
  { value: '"Baloo 2", sans-serif', label: "Baloo 2", provider: 'google' },
  { value: '"Battambang", cursive', label: "Battambang", provider: 'google' },
  { value: '"Bellota Text", cursive', label: "Bellota Text", provider: 'google' },
  { value: '"Be Vietnam Pro", sans-serif', label: "Be Vietnam Pro", provider: 'google' },
  { value: '"Big Shoulders Display", sans-serif', label: "Big Shoulders Display", provider: 'google' },
  { value: '"BioRhyme Expanded", serif', label: "BioRhyme Expanded", provider: 'google' },
  { value: '"Bona Nova", serif', label: "Bona Nova", provider: 'google' },
  { value: '"Bowlby One SC", cursive', label: "Bowlby One SC", provider: 'google' },
  { value: '"Cairo", sans-serif', label: "Cairo", provider: 'google' },
  { value: '"Capriola", sans-serif', label: "Capriola", provider: 'google' },
  { value: '"Carme", sans-serif', label: "Carme", provider: 'google' },
  { value: '"Castoro", serif', label: "Castoro", provider: 'google' },
  { value: '"Charm", cursive', label: "Charm", provider: 'google' },
  { value: '"Chicle", cursive', label: "Chicle", provider: 'google' },
  { value: '"Chilanka", cursive', label: "Chilanka", provider: 'google' },
  { value: '"Code Pro", sans-serif', label: "Code Pro", provider: 'google' },
  { value: '"Cutive Mono", monospace', label: "Cutive Mono", provider: 'google' },
  { value: '"Dawning of a New Day", cursive', label: "Dawning of a New Day", provider: 'google' },
  { value: '"Della Respira", serif', label: "Della Respira", provider: 'google' },
  { value: '"Denk One", sans-serif', label: "Denk One", provider: 'google' },
  { value: '"Devonshire", cursive', label: "Devonshire", provider: 'google' },
  { value: '"Didact Gothic", sans-serif', label: "Didact Gothic", provider: 'google' },
  { value: '"Do Hyeon", sans-serif', label: "Do Hyeon", provider: 'google' },
  { value: '"Doppio One", sans-serif', label: "Doppio One", provider: 'google' },
  { value: '"Duru Sans", sans-serif', label: "Duru Sans", provider: 'google' },
  { value: '"Eczar", serif', label: "Eczar", provider: 'google' },
  { value: '"Esteban", serif', label: "Esteban", provider: 'google' },
  { value: '"Euphoria Script", cursive', label: "Euphoria Script", provider: 'google' },
  { value: '"Fauna One", serif', label: "Fauna One", provider: 'google' },
  { value: '"Federant", serif', label: "Federant", provider: 'google' },
  { value: '"Finlandica", sans-serif', label: "Finlandica", provider: 'google' },
  { value: '"Gidugu", sans-serif', label: "Gidugu", provider: 'google' },
  { value: '"Glegoo", serif', label: "Glegoo", provider: 'google' },
  { value: '"Gothic A1", sans-serif', label: "Gothic A1", provider: 'google' },
  { value: '"Gotu", sans-serif', label: "Gotu", provider: 'google' },
  { value: '"Gowun Dodum", sans-serif', label: "Gowun Dodum", provider: 'google' },
  { value: '"Grandstander", cursive', label: "Grandstander", provider: 'google' },
  { value: '"Grenze", serif', label: "Grenze", provider: 'google' },
  { value: '"Gugi", sans-serif', label: "Gugi", provider: 'google' },
  { value: '"Gupter", serif', label: "Gupter", provider: 'google' },
  { value: '"Gwendolyn", cursive', label: "Gwendolyn", provider: 'google' },
  { value: '"Hina Mincho", serif', label: "Hina Mincho", provider: 'google' },
  { value: '"Holtwood One SC", cursive', label: "Holtwood One SC", provider: 'google' },
  { value: '"Inknut Antiqua", serif', label: "Inknut Antiqua", provider: 'google' },
  { value: '"Ibarra Real Nova", serif', label: "Ibarra Real Nova", provider: 'google' },
  { value: '"Jockey One", sans-serif', label: "Jockey One", provider: 'google' },
  { value: '"Kenia", cursive', label: "Kenia", provider: 'google' },
  { value: '"Kufam", sans-serif', label: "Kufam", provider: 'google' },
  { value: '"La Belle Aurore", cursive', label: "La Belle Aurore", provider: 'google' },
  { value: '"Laila", sans-serif', label: "Laila", provider: 'google' },
  { value: '"Lateef", cursive', label: "Lateef", provider: 'google' },
  { value: '"Lemon", cursive', label: "Lemon", provider: 'google' },
  { value: '"Lexend", sans-serif', label: "Lexend", provider: 'google' },
  { value: '"Linden Hill", serif', label: "Linden Hill", provider: 'google' },
  { value: '"Livvic", sans-serif', label: "Livvic", provider: 'google' },
  { value: '"Lusitana", serif', label: "Lusitana", provider: 'google' },
  { value: '"Macondo", cursive', label: "Macondo", provider: 'google' },
  { value: '"Magra", sans-serif', label: "Magra", provider: 'google' },
  { value: '"Marcellus SC", serif', label: "Marcellus SC", provider: 'google' },
  { value: '"Mate SC", serif', label: "Mate SC", provider: 'google' },
  { value: '"Merienda", cursive', label: "Merienda", provider: 'google' },
  { value: '"Metamorphous", cursive', label: "Metamorphous", provider: 'google' },
  { value: '"Mirza", sans-serif', label: "Mirza", provider: 'google' },
  { value: '"Monda", sans-serif', label: "Monda", provider: 'google' },
  { value: '"Monofett", cursive', label: "Monofett", provider: 'google' },
  { value: '"Mukta", sans-serif', label: "Mukta", provider: 'google' },
  { value: '"Nanum Gothic", sans-serif', label: "Nanum Gothic", provider: 'google' },
  { value: '"Nobile", sans-serif', label: "Nobile", provider: 'google' },
  { value: '"Norican", cursive', label: "Norican", provider: 'google' },
  { value: '"Noticia Text", serif', label: "Noticia Text", provider: 'google' },
  { value: '"Numans", sans-serif', label: "Numans", provider: 'google' },
  { value: '"Odibee Sans", sans-serif', label: "Odibee Sans", provider: 'google' },
  { value: '"Oficna Serif Display", serif', label: "Oficna Serif Display", provider: 'google' },
  { value: '"Orbitron", sans-serif', label: "Orbitron", provider: 'google' },
  { value: '"Oregano", cursive', label: "Oregano", provider: 'google' },
  { value: '"Petrona", serif', label: "Petrona", provider: 'google' },
  { value: '"Poly", serif', label: "Poly", provider: 'google' },
  { value: '"Pompiere", sans-serif', label: "Pompiere", provider: 'google' },
  { value: '"Quattrocento", serif', label: "Quattrocento", provider: 'google' },
  { value: '"Quattrocento Sans", sans-serif', label: "Quattrocento Sans", provider: 'google' },
  { value: '"Rasa", serif', label: "Rasa", provider: 'google' },
  { value: '"Reenie Beanie", cursive', label: "Reenie Beanie", provider: 'google' },
  { value: '"Red Hat Display", sans-serif', label: "Red Hat Display", provider: 'google' },
  { value: '"Red Hat Text", sans-serif', label: "Red Hat Text", provider: 'google' },
  { value: '"Rochester", cursive', label: "Rochester", provider: 'google' },
  { value: '"Sarabun", sans-serif', label: "Sarabun", provider: 'google' },
  { value: '"Share", sans-serif', label: "Share", provider: 'google' },
  { value: '"Short Stack", cursive', label: "Short Stack", provider: 'google' },
  { value: '"Slabo 13px", serif', label: "Slabo 13px", provider: 'google' },
  { value: '"Sniglet", cursive', label: "Sniglet", provider: 'google' },
  { value: '"Squada One", sans-serif', label: "Squada One", provider: 'google' },
  { value: '"Stardos Stencil", cursive', label: "Stardos Stencil", provider: 'google' },
  { value: '"Staatliches", cursive', label: "Staatliches", provider: 'google' },
  { value: '"Tajawal", sans-serif', label: "Tajawal", provider: 'google' },
  { value: '"Tauri", sans-serif', label: "Tauri", provider: 'google' },
  { value: '"Tenali Ramakrishna", sans-serif', label: "Tenali Ramakrishna", provider: 'google' },
  { value: '"Telex", sans-serif', label: "Telex", provider: 'google' },
  { value: '"Text Me One", sans-serif', label: "Text Me One", provider: 'google' },
  { value: '"Tillana", cursive', label: "Tillana", provider: 'google' },
  { value: '"Timmana", sans-serif', label: "Timmana", provider: 'google' },
  { value: '"Trochut", cursive', label: "Trochut", provider: 'google' },
  { value: '"Unkempt", cursive', label: "Unkempt", provider: 'google' },
  { value: '"Vesper Libre", serif', label: "Vesper Libre", provider: 'google' },
  { value: '"Waiting for the Sunrise", cursive', label: "Waiting for the Sunrise", provider: 'google' },
  { value: '"Wire One", sans-serif', label: "Wire One", provider: 'google' },
  { value: '"Zilla Slab Highlight", serif', label: "Zilla Slab Highlight", provider: 'google' },
];

// Merge them if needed
export const FONT_OPTIONS: FontOption[] = [
  ...WEB_SAFE_FONTS,
  ...GOOGLE_FONTS,
];
